import { render, staticRenderFns } from "./paramssetting.vue?vue&type=template&id=7f04ada0&scoped=true&"
import script from "./paramssetting.vue?vue&type=script&lang=js&"
export * from "./paramssetting.vue?vue&type=script&lang=js&"
import style0 from "./paramssetting.vue?vue&type=style&index=0&id=7f04ada0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04ada0",
  null
  
)

export default component.exports